import { getChoresClient } from "../client";
import { getCurrentSelectedTenant } from "../utils";
import { ChoreList } from "@securityjourney/frontend-lib-svc";

export const fetchUserChores = async (): Promise<ChoreList> => {
  const client = getChoresClient();

  const forTenant = getCurrentSelectedTenant();
  const { promise } = client.myChores(forTenant ?? undefined);
  const data = await promise;
  return data;
};
